module.exports = "/_next/static/images/21503b498acd15079de4bd864e0f58f5-moneyboxes-right-desktop.jpg.webp";